module.exports = __webpack_public_path__ + "img/tell.dfd4681b.png";